export default {
    namespaced:true,
    actions:{ //通过$store.dispatch
        changeuserinfo(context,value){
            context.commit('CHANGE_USERINFO',value)
        },
        //清空用户数据
        clearnuserinfo(context){
            context.commit('CLEARN_USERINFO')
        }
    },
    mutations:{ //通过$store.commit
        CHANGE_USERINFO(state,value){
            state.user = value;
            // state.user.username = value.username;
            // state.user.phone = value.phone;
        },
        CLEARN_USERINFO(state){
            //清空state中user的内容
            state = {}
            //清空sessionStorage中的存储内容
            // sessionStorage.clear()
        }
    },
    state:{
        // user:{
        //     // username:'', //用户真实姓名
        //     // name:'', //用户登录账号(邮箱)
        //     // phone:'' //用户手机号
        // }
    },
    getters:{

    },
}